import React, { useState } from 'react';
import Image from 'next/image';
import { motion, AnimatePresence } from 'framer-motion';

const faqData = [
  {
    question: 'Trứng gà của bạn có nguồn gốc từ đâu?',
    answer:
      'Trứng gà của chúng tôi được cung cấp từ các trang trại uy tín, có chứng nhận chất lượng và đảm bảo vệ sinh an toàn thực phẩm. Tất cả các trang trại đều được kiểm tra định kỳ và tuân thủ các tiêu chuẩn nghiêm ngặt về chăn nuôi.',
  },
  {
    question: 'Quy trình bảo quản trứng như thế nào?',
    answer:
      'Trứng gà được thu hoạch hàng ngày và được bảo quản trong môi trường nhiệt độ thích hợp, đảm bảo độ tươi ngon. Chúng tôi sử dụng hệ thống kho lạnh chuyên dụng và vận chuyển bằng xe có thiết bị làm mát để đảm bảo chất lượng sản phẩm đến tay khách hàng.',
  },
  {
    question: 'Bạn có giao hàng tận nơi không?',
    answer:
      'Có, chúng tôi cung cấp dịch vụ giao hàng tận nơi trên toàn quốc. Với hệ thống phân phối rộng khắp, chúng tôi cam kết giao hàng nhanh chóng, đảm bảo trứng gà luôn tươi mới khi đến tay khách hàng. Phí vận chuyển sẽ được tính dựa trên khoảng cách và số lượng đơn hàng.',
  },
  {
    question: 'Làm thế nào để đặt hàng?',
    answer:
      'Bạn có thể đặt hàng qua nhiều cách: gọi điện trực tiếp đến hotline, liên hệ qua Zalo, email hoặc đến trực tiếp cửa hàng. Chúng tôi sẽ tư vấn và hỗ trợ bạn chọn sản phẩm phù hợp nhất với nhu cầu.',
  },
];

const mainImage =
  '/images/anh11.jpg';
// const mainImage =
//   'https://i.pinimg.com/1200x/68/c3/12/68c31256aaa1883c9ac5b6b59036660f.jpg';

const overlayImage =
  'https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="container py-8 md:py-16 overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-start">
        {/* Gallery Section - Left */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative w-full h-[400px] md:h-[600px] lg:h-[700px]"
        >
          {/* Main Image */}
          <div className="relative w-full h-full rounded-2xl overflow-hidden">
            <Image
              src={mainImage}
              alt="Nhà xưởng sản xuất"
              fill
              className="object-cover"
              sizes="(max-width: 1024px) 100vw, 50vw"
            />
          </div>

          {/* FAQ Text Overlay */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="absolute bottom-0 left-0 p-6 md:p-8"
          >
            {/* <h2 className="text-white text-[48px] md:text-[72px] lg:text-[96px] font-bold uppercase tracking-tight leading-none opacity-90">
              FAQ
            </h2> */}
          </motion.div>

          {/* Small Overlay Image */}
          {/* <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="absolute bottom-8 left-8 md:bottom-12 md:left-12 w-[120px] md:w-[180px] h-[90px] md:h-[135px] rounded-xl overflow-hidden shadow-2xl border-4 border-white"
          >
            <Image
              src={overlayImage}
              alt="Hình ảnh nhà xưởng"
              fill
              className="object-cover"
              sizes="(max-width: 768px) 120px, 180px"
            />
          </motion.div> */}
        </motion.div>

        {/* FAQ Section - Right */}
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex flex-col gap-6 md:gap-8"
        >
          <motion.h2
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-[24px] md:text-[32px] uppercase font-bold text-gray2"
          >
            Tìm hiểu về quy trình sản xuất
          </motion.h2>

          <div className="flex flex-col gap-4">
            {faqData.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="border-b border-gray-200 pb-4 last:border-b-0"
              >
                <button
                  onClick={() => handleToggle(index)}
                  className="w-full flex items-center justify-between gap-4 text-left group"
                  aria-expanded={openIndex === index}
                  aria-label={item.question}
                >
                  <span className="text-[18px] md:text-[20px] font-semibold text-gray2 group-hover:text-primary transition-colors duration-300 flex-1">
                    {item.question}
                  </span>
                  <motion.div
                    animate={{ rotate: openIndex === index ? 45 : 0 }}
                    transition={{ duration: 0.3 }}
                    className="flex-shrink-0 w-6 h-6 md:w-8 md:h-8 flex items-center justify-center text-primary text-2xl md:text-3xl font-light"
                  >
                    +
                  </motion.div>
                </button>

                <AnimatePresence>
                  {openIndex === index && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3, ease: 'easeInOut' }}
                      className="overflow-hidden"
                    >
                      <motion.p
                        initial={{ y: -10 }}
                        animate={{ y: 0 }}
                        exit={{ y: -10 }}
                        transition={{ duration: 0.3 }}
                        className="pt-4 text-[16px] md:text-[18px] text-gray-600 leading-relaxed"
                      >
                        {item.answer}
                      </motion.p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
